// extracted by mini-css-extract-plugin
module.exports = {"container":"OverlayContent_container__B6GXG","visible":"OverlayContent_visible__lHcqk"};